import React from "react";

import axios from "axios";
import { useQuery } from 'react-query'
import numeral from "numeral";

// import { SelectColumnFilter } from "../../components/ui/components/RTable";
import { urls } from "../../common";
import { formatDate } from "../../common/dates";
import Button from "../../components/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faPlus, faPoundSign, faXmark } from "@fortawesome/pro-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Table from "../../components/Table";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { handleAdminDeleteClick } from "./common";
import { useUser } from "../../context/User";


const AdminList = () => {
    const { user } = useUser();

    const { isLoading, isError, data, error, refetch } = useQuery(`admin`, () => axios.get(urls.remoteURL + `admin/all`));


    const actionCell = (info: CellContext<TableProps, string>) => {
        return (
            <div className="flex gap-2">
                {/* {value} */}
                <Button
                    to={`${info.getValue()}`}
                    color="green"
                // className={'rounded sm:p-1'}
                ><span className="sr-only">Edit Administrator</span>
                    <FontAwesomeIcon icon={faPencil} fixedWidth aria-hidden="true" /> </Button>
                <Button
                    type="button"
                    color="red"
                    disabled={user?.id === info.getValue()}
                    // className={'rounded sm:p-1'}
                    onClick={(e) => handleAdminDeleteClick(info.getValue(), refetch)}><span className="sr-only">Delete Admin</span>
                    <FontAwesomeIcon icon={faXmark} fixedWidth aria-hidden="true" /> </Button>
            </div>
        );
    }



    type TableProps = {
        id: string,
        firstname: string,
        lastname: string,
        email: string,
        created: number,
    }


    const columnHelper = createColumnHelper<TableProps>();
    const columns = [
        columnHelper.accessor('firstname', {
            // cell: statusCell,
            header: 'First Name',
            footer: 'Last Name',
            sortingFn: 'alphanumeric',
        }),

        columnHelper.accessor('email', {
            // cell: statusCell,
            header: 'Owner',
            footer: 'Owner',
            sortingFn: 'alphanumeric',
        }),

        columnHelper.accessor('created', {
            cell: info => formatDate({ time: info.getValue() }),
            header: 'Created',
            footer: 'Created',
            sortingFn: 'alphanumeric',
        }),


        columnHelper.accessor('id', {
            header: 'Actions',
            footer: 'Actions',
            cell: info => actionCell(info),
            enableSorting: false,
            enableGlobalFilter: false,
            meta: {
                className: 'w-28 text-center'
            }
        }),
    ];

    const rows = React.useMemo(() => {
        if (isLoading === false) {
            return Object.values(data?.data);
        } else {
            return [];
        }
    }, [data?.data]);

    return (
        <>{
            isLoading === false &&
            <Table columns={columns} defaultData={rows} />
        }
        </>
    )
}

export default AdminList;